import React from "react"
import { Progress as CustomProgress, ProgressProps } from "antd"

const Progress: React.FC<ProgressProps> = ({ percent = 0, ...rest }) => (
  <CustomProgress size="small" percent={Math.trunc(percent)} {...rest} />
)

export default Progress
